<template>
  <div>
    <label v-if="label" :for="labelFor" class="block text-md font-albert text-brand-black/70" :class="[msg ? 'mb-0' : 'mb-2']">{{ label }}</label>
    <p v-if="msg" class="text-xs font-noraml text-brand-black/40">{{ msg }}</p>
    <div class="flex">
      <span
        v-if="side"
        class="inline-flex items-center px-5 py-2 text-base text-white bg-[#172A49] rounded-l-md border rounded border-r-0 border-gray-300"
      >
        $
      </span>
      <textarea
        v-if="type == 'textarea'"
        rows="7"
        :id="id"
        :value="modelValue"
        @input="$emit('update:modelValue', $event.target.value)"
        class="block w-full px-4 py-4 text-sm text-brand-primary border border-gray-300 rounded-lg bg-white placeholder:text-gray-500 text-[14px]"
        :placeholder="placeholder"
        :minlength="minlength"
      ></textarea>

      <input
        v-else
        :type="type"
        :id="id"
        :value="modelValue"
        @input="$emit('update:modelValue', $event.target.value)"
        class="block w-full p-4 text-sm text-brand-primary border border-gray-300 rounded-lg bg-white placeholder:text-gray-500 text-[14px]"
        :placeholder="placeholder"
        :minlength="minlength"
      />
    </div>
  </div>
</template>

<script setup>
import { onMounted } from 'vue';

const props = defineProps({
  label: String,
  id: {
    type: String,
    default: () => `id${Math.random() * 3}`,
  },
  type: {
    type: String,
    default: 'text',
  },
  placeholder: String,
  labelFor: String,
  modelValue: String | Number,
  msg: String,
  side: Boolean,
  isRequired: {
    type: Boolean,
    default: false,
  },
  minlength: Number,
});

onMounted(() => {
  if (props.isRequired) {
    document.getElementById(props.id)?.setAttribute('required', true);
  }
});
</script>
